import { render, staticRenderFns } from "./MainPageRunningHourNew.vue?vue&type=template&id=22787025&scoped=true"
import script from "./MainPageRunningHourNew.vue?vue&type=script&lang=js"
export * from "./MainPageRunningHourNew.vue?vue&type=script&lang=js"
import style0 from "./MainPageRunningHourNew.vue?vue&type=style&index=0&id=22787025&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22787025",
  null
  
)

export default component.exports